import { createContext, useContext, useEffect, useState } from 'react';
import { getTokenId } from '../../FirebaseInit';

const TokenContext = createContext();

export function useToken() {
  return useContext(TokenContext);
}

function TokenProvider({ children }) {
  const [tokenFound, setTokenFound] = useState('');
  // Check notification permission status
  const checkNotificationStatus = () => {
    return permission;
  };

  useEffect(() => {
    async function initializeToken() {
      try {
        const permission = Notification.permission;
        const tokenlastUpdate = localStorage.getItem('tokenlastUpdate');

        // Check if tokenlastUpdate is before 10 days from now
        const currentTime = new Date().getTime();

        const tenDaysAgo = currentTime - 10 * 24 * 60 * 60 * 1000;
        const isTokenOld = !tokenlastUpdate || parseInt(tokenlastUpdate) < tenDaysAgo;

        if (permission === 'granted' && isTokenOld) {
          const fcmToken = await getTokenId(setTokenFound);
          localStorage.setItem('tokenlastUpdate', new Date().getTime());
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }

    initializeToken();
  }, []);

  return <TokenContext.Provider value={{}}>{children}</TokenContext.Provider>;
}

export default TokenProvider;
